<template>
  <div class="vz-layout vz-layout-default">
    <nuxt />
    <vz-dialog
      :active="dialog.active"
      :title="dialog.title"
      :type="dialog.type"
      :buttons="dialog.buttons"
    >
      {{ dialog.text }}
    </vz-dialog>
  </div>
</template>

<script>
import VzDialog from 'vsp-web-ui-lib/components/organisms/vz-dialog.vue';
import Base from './_base.vue';

export default {
  name: 'DefaultLayout',
  extends: Base,
  components: {
    VzDialog
  },

  computed: {
    dialog() {
      return this.$store.state.ui.dialog;
    }
  }
};
</script>

<style>
@import '~theme/style.css';
@import '~client/style.css';
</style>
